import { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { useMutation } from '@tanstack/react-query';

import { useTicketsClient } from 'services/api';
import { TicketDownloadUrlDocument } from 'types/api/tickets.types';

import { AppSyncTicketsGraphQLError } from './types';

// A mutation is used here as it's a response to user interaction,
// allowing us to handle outcomes like onSuccess and onError, which aligns with the side-effect nature of mutations.
export const useTicketDownloadUrl = () => {
  const ticketsClient = useTicketsClient();

  const { mutate, isPending, isPaused } = useMutation<
    ResultOf<typeof TicketDownloadUrlDocument>,
    AppSyncTicketsGraphQLError,
    VariablesOf<typeof TicketDownloadUrlDocument>
  >({
    mutationFn: (ticketId) =>
      ticketsClient.request(TicketDownloadUrlDocument, ticketId),
    retry: false,
  });

  return {
    requestTicketDownloadUrl: mutate,
    isLoading: isPending && !isPaused,
  };
};
